 document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('.menu-toggle');
  const mainNav = document.querySelector('.main-nav');
  menuToggle?.addEventListener('click', () => {
    const open = mainNav?.classList.toggle('open');
    menuToggle.setAttribute('aria-expanded', String(Boolean(open)));
  });
  mainNav?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      mainNav.classList.remove('open');
      menuToggle?.setAttribute('aria-expanded', 'false');
    });
  });
  const shopHashes = ['#duzit-shop', '#shop', '#katalog', '#duz-city'];
  const openShop = () => {
    document.body.classList.add('duzit-shop-open');
    requestAnimationFrame(() => document.querySelector('#duzit-shop')?.scrollIntoView({ block: 'start' }));
  };
  if (shopHashes.includes(window.location.hash)) openShop();
  document.querySelector('[data-enter-site]')?.addEventListener('click', (event) => {
    if (event.currentTarget.getAttribute('href') === '#duzit-shop') {
      event.preventDefault();
      history.replaceState(null, '', '#duzit-shop');
      openShop();
    }
  });
  window.addEventListener('hashchange', () => {
    if (shopHashes.includes(window.location.hash)) {
      document.body.classList.add('duzit-shop-open');
      requestAnimationFrame(() => document.querySelector(window.location.hash)?.scrollIntoView({ block: 'start' }));
    }
    else document.body.classList.remove('duzit-shop-open');
  });

  const count = document.querySelector('[data-visitor-count]');
  if (count) {
    const key = 'duzit_portal_passages';
    const next = Number(localStorage.getItem(key) || 0) + 1;
    localStorage.setItem(key, String(next));
    count.textContent = String(next).padStart(6, '0');
  }

  const productThumbs = [...document.querySelectorAll('[data-thumb-url]')];
  const mainProductImage = document.querySelector('[data-main-product-image]');
  let productMediaIndex = 0;
  const showProductMedia = (nextIndex) => {
    if (!mainProductImage || !productThumbs.length) return;
    productMediaIndex = (nextIndex + productThumbs.length) % productThumbs.length;
    const activeThumb = productThumbs[productMediaIndex];
    mainProductImage.removeAttribute('srcset');
    mainProductImage.removeAttribute('sizes');
    mainProductImage.src = activeThumb.dataset.thumbUrl;
    mainProductImage.dataset.productMediaIndex = String(productMediaIndex);
    productThumbs.forEach((thumb, index) => thumb.classList.toggle('is-active', index === productMediaIndex));
  };
  productThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showProductMedia(index)));
  showProductMedia(0);

  document.querySelectorAll('[data-product-accordion]').forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      document.querySelectorAll('[data-product-accordion]').forEach((other) => {
        if (other !== item) other.open = false;
      });
    });
  });

  const form = document.querySelector('[data-product-form]');
  const clearCartButton = document.querySelector('[data-clear-cart]');
  if (clearCartButton) {
    clearCartButton.addEventListener('click', async () => {
      if (!window.confirm('Vider entièrement le panier ?')) return;
      const clearStatus = document.querySelector('[data-cart-clear-status]');
      clearCartButton.disabled = true;
      if (clearStatus) clearStatus.textContent = 'SUPPRESSION DU PANIER…';
      try {
        const response = await fetch(`${window.duzitRoutes.cart}/clear.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Impossible de vider le panier.');
        window.location.reload();
      } catch (error) {
        if (clearStatus) clearStatus.textContent = error.message;
        clearCartButton.disabled = false;
      }
    });
  }
  if (!form) return;
  const select = form.querySelector('select[name="id"]');
  const price = document.querySelector('[data-product-price]');
  const status = form.querySelector('[data-form-status]');
  const submit = form.querySelector('button[type="submit"]');
  const stockCounter = form.querySelector('[data-stock-counter]');

  const stockBadge = document.querySelector('[data-stock-badge]');
  const addLabel = form.querySelector('[data-add-label]');
  const updateVariant = () => {
    const option = select?.options[select.selectedIndex];
    if (!option) return;
    const available = option.dataset.available === 'true';
    const tracked = option.dataset.tracked === 'true';
    const stock = Math.max(0, Number(option.dataset.stock || 0));
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    submit.disabled = !available;
    if (addLabel) addLabel.textContent = available ? 'AJOUTER AU PANIER' : 'ÉPUISÉ';
    if (stockCounter) stockCounter.textContent = !available ? 'ÉPUISÉ' : tracked ? `EXEMPLAIRES RESTANTS : ${stock}` : 'DISPONIBLE';
    if (stockBadge) stockBadge.textContent = !available ? 'ÉPUISÉ' : !tracked ? 'DISPONIBLE' : stock > 1 ? `TI SÉRI · ${stock} EXEMPLAIRES` : 'DERNIER EXEMPLAIRE';
    const imageUrl = option.dataset.image || mainProductImage?.dataset.defaultImage;
    if (mainProductImage && imageUrl) {
      mainProductImage.removeAttribute('srcset');
      mainProductImage.src = imageUrl;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState(null, '', url);
    if (status) status.textContent = '';
  };
  if (mainProductImage) mainProductImage.dataset.defaultImage = mainProductImage.src;
  select?.addEventListener('change', updateVariant);
  if (select) updateVariant();

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (submit.disabled || !form.reportValidity()) return;
    submit.disabled = true;
    status.textContent = 'CONNEXION AU PANIER…';
    try {
      const response = await fetch(window.duzitRoutes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        throw new Error(errorBody.description || 'Impossible d’ajouter ce produit.');
      }
      const cartResponse = await fetch(window.duzitRoutes.cartJson, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) {
        status.textContent = 'AJOUTÉ ✓ — Consulte ton panier pour continuer.';
        return;
      }
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
      status.textContent = 'AJOUTÉ ✓';
      setTimeout(() => { status.innerHTML = `<a href="${window.duzitRoutes.cart}">VOIR LE PANIER →</a>`; }, 700);
    } catch (error) {
      status.textContent = error.message;
    } finally {
      submit.disabled = false;
    }
  });
});
